// extracted by mini-css-extract-plugin
export default {"elevatedSprite":"ElevatedSprite_elevatedSprite__kylG1","bodyContainer":"ElevatedSprite_bodyContainer__2Ns-T"};